<template>
  <b-modal
    id="downloadFileModal"
    :centered="true"
    title="Download Claim"
    :hide-footer="true"
    @shown="getDownloadFiles"
    size="md"
    no-close-on-backdrop
  >
    <div class="table-responsive">
      <table class="table w-100">
        <thead class="">
          <tr>
            <th style="border-top: 0">File name</th>
            <th style="border-top: 0">Download</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, index) in files" :key="index">
            <td>{{ file.filename }}</td>
            <td class="">
              <div
                class="action-download"
                v-b-tooltip.hover
                title="Download"
                @click="downloadFile(file.url)"
              >
                <i class="fas fa-download"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      files: [],
    };
  },
  methods: {
    downloadFile(link) {
      window.open(link, "_blank");
    },

    getDownloadFiles() {
      let loader = this.$loading.show();
      let url = "prudential-claim/get-prudential-form";
      axios
        .get(url)
        .then((res) => {
          if (res.data.status === "success") {
            this.files = res.data.data;

            console.log(this.files);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>